export enum Subscription {
    DorstBasic = 'Dorst Basic',
    DorstPro = 'Dorst Pro',
    DorstPremium = 'Dorst Premium',
}
